

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {Globals} from '../../../../globals';
import { environment } from '../../../../../environments/environment';


@Injectable({
    providedIn: 'root'
})
export class FormBuilderService {

    constructor(private http: HttpClient,
                private globals: Globals) { }


  getValidValues(ValidValueName: string ): Observable<any[]> {
    let url: string;
    const method: string = `valid-values-v2/getValidValuesItems-by-validValueName/${ValidValueName}`;
    url = environment.TDOurl + method;
    return this.http.get<any>(url);
  }

  getListOfForms(searchText: string): Observable<any[]> {
    let url: string;
    const method: string = `forms/getCfgDFormListV2/${searchText}`;
    url = environment.TDOurl + method;
    return this.http.get<any>(url);
  }


  getCfgDFormVersionList(DFormId: string): Observable<any[]> {
    let url: string;
    const method: string = `forms/getCfgDFormVersionListV2/${DFormId}`;
    url = environment.TDOurl + method;
    return this.http.get<any>(url);
  }

  creteNewCfgDForm(): Observable<any> {
    let url: string;
    const method: string = `forms/getCfgDFormCreateNewFormV2`;
    url = environment.TDOurl + method;
    return this.http.get<any>(url);
  }

  deleteCfgDForm(DFormId: string): Observable<any> {
    let url: string;
    const method: string = `forms/getCfgDFormDeleteV2/${DFormId}`;
    url = environment.TDOurl + method;
    return this.http.get<any>(url);
  }

  getCfgDFormParagrahList(DFormVersionId: string): Observable<any[]> {
    let url: string;
    const method: string = `forms/getcfgDFormParagraphV2/${DFormVersionId}`;
    url = environment.TDOurl + method;
    return this.http.get<any[]>(url);
  }

  getCfgDFormItemList(DFormVersionId: string): Observable<any[]> {
    let url: string;
    const method: string = `forms/getcfgDFormItemV2/${DFormVersionId}`;
    url = environment.TDOurl + method;
    return this.http.get<any[]>(url);
  }




    /*
  getClients(): Observable<any[]> {
    let url: string;
    const method: string = 'client-office-location/tdo-clients';
    url = environment.TDOurl + method;
    return this.http.get<any>(url);
  }


  saveOps(isNew: boolean, locToSave: any): Observable<any> {
    let url: string;
    if (isNew) {
      const method: string = 'ClientOfficeLocationConfiguration/TDONewLocationCreate';
      url = environment.TDOurl + method;
      return this.http.post<any>(url, locToSave);
    } else {
      const method: string = 'ClientOfficeLocationConfiguration/TDOLocationUpdate';
      url = environment.TDOurl + method + '/' + locToSave.LOCID;
      return this.http.put<any>(url, locToSave);
    }
  }

   */
}
